import { useState } from "react";
import { useAppContext } from "../../../../context/AuthContext";
import { ClassIdGeneratorSocket, Lecture } from "../../../../controller";
import LectureDto from "../../../../interfaces/lecture/LectureDto";
import { useEffectOnce,  } from "../../../../utils/Utils";
import { wsEvents } from "../../../../constants";
import MessageType from "../../../../utils/MessageType";
import { set } from "lodash";

interface MyLecturesServiceType {
  lectures: Array<LectureDto>;
  openMenuLecture: number | null;
  handleOpenMenu: (id: number) => void;
  handleCloseMenu: () => void;
  anchorEl: any;
  setAnchorEl: any;
  sendEmails: (emails: string) => void;
  isLoading: boolean;
 
}

export default function MyLecturesService(): MyLecturesServiceType {
  const { selectedCourse, showMessage, updateSelectedLecture } = useAppContext();
  const [lectures, setLectures] = useState<LectureDto[]>([]);
  const [openMenuLecture, setOpenMenuLecture] = useState<number | null>(null);
  const [anchorEl, setAnchorEl] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false);


  useEffectOnce(() => {
    getLectures();

    return () => {
      ClassIdGeneratorSocket.disconnect();
      ClassIdGeneratorSocket.off(wsEvents.recv.CLASS_IDS_GENERATED, classIdsGenerated);
    };
  });

  const classIdsGenerated = () => {
    // Handle class IDs generated event
    setIsLoading(false);
    showMessage("Meeting codes sent successfully!", MessageType.SUCCESS);
  };

  const getLectures = () => {
    Lecture.getCourseLectures(selectedCourse.id)
      .then(({ data }: any) => {
        if (data?.message) {
          setLectures(data.data);

          

          ClassIdGeneratorSocket.connect({ query: { courseId: selectedCourse.id, lectureNum: data.data[0]?.lectureNum } });
          ClassIdGeneratorSocket.on(wsEvents.recv.CLASS_IDS_GENERATED, classIdsGenerated);
        } else {
          setIsLoading(false);
          console.error(data);
        }
      })
      .catch((err) => console.error(err));
  };

  const handleOpenMenu = (id: number) => setOpenMenuLecture(id);

  const handleCloseMenu = () => {
    setOpenMenuLecture(null);
    setAnchorEl(null);
  };

  const sendEmails = (emails: string) => {
    setIsLoading(true);
    ClassIdGeneratorSocket.emit(wsEvents.send.START_CLASS_ID_GENERATION_BY_EMAILS, { emails: emails });
  };



  return { lectures, openMenuLecture, handleOpenMenu, handleCloseMenu, anchorEl, setAnchorEl, sendEmails, isLoading };
}

export type { MyLecturesServiceType };
